import React from 'react';
import PropTypes from 'prop-types';

import AccountBlock from './AccountBlock';
import withModal from '../../../../../../components/global/modal/withModal';

export const ACCOUNT_BLOCK_MODAL = 'modal/ACCOUNT_BLOCK';

const propTypes = {
  actionProps: PropTypes.shape({
    account: PropTypes.shape({
      id: PropTypes.string,
    }),
    onAccountBlockCreated: PropTypes.func,
  }),
};

const AccountBlockModal = ({
  actionProps: { account, onAccountBlockCreated },
  onRequestClose,
  ...props
}) => {
  return (
    <AccountBlock
      account={account}
      onAccountBlockCreated={onAccountBlockCreated}
      onClose={onRequestClose}
      {...props}
    />
  );
};

AccountBlockModal.propTypes = propTypes;

export default withModal(AccountBlockModal, {
  name: ACCOUNT_BLOCK_MODAL,
  size: 'sm',
});
